module.exports = __webpack_public_path__ + "static/media/ETH-BNB.444d7678.png";